<template>
	<div class="small-12 addForm addResident animated fadeInRight border-top border-right" v-if="open_menu" v-bind:class="{ active: open_menu }">
		<div class="small-12 columns panelMenuWrapper">
			<div class="small-12 formTitle border-bottom">
				<h2 class="small-12 flex vertical-align justify-between">
					<span class="float-left small-8">
						Create a Lease
					</span>
					<i class="material-icons-outlined transition" @click="closeMenu()">cancel</i>
				</h2>
				<div class="small-12">
					<ul class="small-12 flex vertical-align float-left attributes">
						<li>
							<p>
								<b>For: </b>
								{{ resident.attributes.contact_information.first_name }} {{ resident.attributes.contact_information.last_name }}
							</p>
						</li>
					</ul>
				</div>	
			</div>
			<div class="small-12 formBody" v-if="property">
				<div class="small-12 image borderRadius8">
					<picture class="flex small-12 justify-center vertical-align">
						<img width="79" :src="vector_image" alt="A lease crawling out of the browser." style="width:119px;">
					</picture>
				</div>
				<div class="small-12 sectionTitle flex first">
					<h2>Lease Information</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Status<em class="cRed">*</em></label>
					<div class="small-12 selectContainer borderRadius8 flex vertical-align" v-if="lease_options">
						<select name="status" class="small-12" v-model="new_lease.attributes.status" @change="statusValidation()">
							<option :value="null" selected disabled>Please Choose...</option>
							<option :value="statusOption.value" v-for="(statusOption, statusOptionIndex) in lease_options.statuses" :selected="new_lease.attributes.status == statusOption.value ? true : false" :key="statusOptionIndex">{{statusOption.title}}</option>
						</select>
					</div>
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="status.error">
						<small class="cRed small-12">{{status.title}}</small>
					</div>
				</fieldset>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Lease Type<em class="cRed">*</em></label>
					<div class="small-12 selectContainer borderRadius8 flex vertical-align" v-if="lease_options">
						<select name="lease_type" class="small-12" v-model="new_lease.type" @change="leaseTypeValidation()">
							<option :value="null" selected disabled>Please Choose...</option>
							<option :value="typeOption.value" v-for="(typeOption, typeOptionIndex) in lease_options.lease_types_residential" :selected="new_lease.type == typeOption.value ? true : false" :key="typeOptionIndex">{{typeOption.title}}</option>
						</select>
					</div>
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="lease_type.error">
						<small class="cRed small-12">{{lease_type.title}}</small>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex">
					<h2>Lease Term</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<div class="small-12">
						<label class="small-12">Start Date<em class="cRed">*</em></label>
						<div class="small-12" @click="setCalendarPickerIndex($event)">
							<datetime v-model="new_lease.attributes.details.start_date" value-zone="local" zone="local" :phrases="{ok: 'Select', cancel: 'Cancel'}" :format="{ month: 'numeric', day: 'numeric', year: 'numeric' }" @input="validateTermDates($event)"></datetime>
						</div>
					</div>
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="start_date.error">
						<small class="cRed small-12">{{start_date.title}}</small>
					</div>
				</fieldset>
				<fieldset class="small-12 flex inputGroup">
					<div class="small-12">
						<label class="small-12">End Date<em class="cRed">*</em></label>
						<div class="small-12" @click="setCalendarPickerIndex($event)">
							<datetime v-model="new_lease.attributes.details.end_date" value-zone="local" zone="local" :phrases="{ok: 'Select', cancel: 'Cancel'}" :format="{ month: 'numeric', day: 'numeric', year: 'numeric' }" @input="validateTermDates($event)"></datetime>
						</div>
					</div>
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="end_date.error">
						<small class="cRed small-12">{{end_date.title}}</small>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex">
					<h2>Lease Documents</h2>
				</div>
				<fieldset class="small-12 flex inputGroup" style="margin-bottom:30px;">
					<div class="small-12 flex vertical-align">
						<div class="small-12 large-3 toggle-button">
							<toggle-button v-model="new_lease.attributes.details.signature" color="#18bbf7" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" :width="90" :height="40" :font-size="14"/>
						</div>
						<div class="labelDefinitions small-12 large-9 columns flex vertical-align">
							<p class="small-12 columns"><b>Signature Acquired</b></p>
							<span class="small-12 columns">Do you have a signed lease?</span>
						</div>
					</div>
					<div class="small-12 animated fadeIn leaseDocumentUpload" style="margin-top:20px;" v-if="new_lease.attributes.details.signature">
						<label class="small-12">Upload lease documents</label>
						<div class="small-12 fileUploadWrap borderRadius7">
							<div class="small-12 fileUploadArea upload flex vertical-align justify-center">
								<file-pond ref="pond" allow-multiple="false" max-files="1" accepted-file-types="image/jpeg, image/png, application/pdf" :server="{  process, load }" @error="handleFilePondError" :allowFileSizeValidation="true" max-file-size="1000MB" label-max-file-size-exceeded="File is too large."></file-pond>
							</div>
						</div>
						<div class="small-12 uploadedDocuments" v-if="new_lease.links.documents.length > 0">
							<label class="small-12">Upload Documents</label>
							<ul class="small-12 flex float-left">
								<li class="small-12 columns" v-for="(doc, docIndex) in new_lease.links.documents" :key="docIndex">
									<uploaded-document :doc="doc"/>
								</li>
							</ul>
						</div>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex">
					<h2>Lease Renewal</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<div class="small-12 flex vertical-align">
						<div class="small-12 large-3 toggle-button">
							<toggle-button v-model="new_lease.attributes.renewal.send_notice" color="#18bbf7" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" :width="90" :height="40" :font-size="14" @change="validateNoticeDate($event)"/>
						</div>
						<div class="labelDefinitions small-12 large-9 columns flex vertical-align">
							<p class="small-12 columns"><b>Renewal Notice</b></p>
							<span class="small-12 columns">Send your resident a renewal notice before lease expires?</span>
						</div>
					</div>
					<div class="small-12 animated fadeIn" style="margin-top:16px; position: relative; z-index:2;" v-if="new_lease.attributes.renewal.send_notice">
						<label class="small-12">Notice Date<em class="cRed">*</em></label>
						<div class="small-12" @click="setCalendarPickerIndex($event)">
							<datetime v-model="new_lease.attributes.renewal.notice_date" value-zone="local" zone="local" :phrases="{ok: 'Select', cancel: 'Cancel'}" :format="{ month: 'numeric', day: 'numeric', year: 'numeric' }" @input="validateNoticeDate($event)"></datetime>
						</div>
					</div>
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="notice_date.error">
						<small class="cRed small-12">{{notice_date.title}}</small>
					</div>
				</fieldset>
			</div>
		</div>
		<div class="small-12 columns panelActions flex justify-center vertical-align border-top">
			<a class="blueButton small-5 flex borderRadius4 vertical-align" @click="createLeaseHandler()" style="max-width:154px;" v-if="enableCreateButton">
				<i class="material-icons flex vertical-align justify-center">save</i>
				Create Lease
			</a>
			<a class="disabledButton small-5 flex borderRadius4 vertical-align" style="max-width:154px;" v-else>
				<i class="material-icons flex vertical-align justify-center">save</i>
				Create Lease
			</a>
		</div>
	</div>
</template>

<script>

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { LeasesRepository } from '@/repositories/leases/LeasesRepository'
	import { FilepondService } from '@/mixins/services/filepond/FilepondService'

	// Import the events
	import { GetLeaseOptions } from '@/events/config/GetLeaseOptions'
	import { UploadFileToStorage } from '@/events/files/UploadFileToStorage'
	import { CreateLease } from '@/events/leases/CreateLease'
	import { GetActiveLease } from '@/events/leases/GetActiveLease'

	// Import the components
	import UploadedDocument from '@/components/property/leases/UploadedDocument.vue'
	import { Datetime } from 'vue-datetime'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'AddLeaseMenu',

		/*
		**  Register the components
		*/

		components: {

			UploadedDocument,
			datetime: Datetime

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			LeasesRepository,
			FilepondService,
			GetLeaseOptions,
			UploadFileToStorage,
			CreateLease,
			GetActiveLease

		],

		/*
		**  Set the props
		*/

		props: {

			menu_action: {
				type: Boolean,
				default: false
			},

			property: {
				type: Object,
				default: () => null
			},

			company: {
				type: Object,
				default: () => null
			},

			resident: {
				type: Object,
				default: () => null
			},

			unit: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			vector_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fpage-writing-screen.svg?alt=media&token=eb566a75-e922-4ec0-9c47-0f1e5b4f6522',
			empty_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/logos%2Fnestd-logo-house.svg?alt=media&token=782a6239-e56b-4366-9ed5-b278ad5ea9e4',
			open_menu: false,
			lease_options: null,
			active_lease_exists: false,
			lease_in_past: false,
			end_date_greater_than_beginning_date: true,
			valid_term_dates: false,
			valid_renewal_date: false,
			enableCreateButton: false,
			status: {
				error: false,
				title: null
			},
			lease_type: {
				error: false,
				title: null
			},
			start_date: {
				error: false,
				title: null
			},
			end_date: {
				error: false,
				title: null
			},
			notice_date: {
				error: false,
				title: null
			}

		}),

		/*
		**  Watch em'
		*/

		watch: {

			menu_action: {

				immediate: true, // Load on created
				handler(menu_action) {

					/*
					**  Open the menu
					**  @method: @here
					*/

					if (menu_action) this.openTheMenu();
				}

			},

			file_download: {

				immediate: true, // Load on created
				handler(file_download) {

					/*
					**  Set the documents prop
					**  @method: @here
					*/

					if (file_download) this.setDocumentsProp();
				}

			},

			resident: {

				immediate: true, // Load on created
				handler(resident) {

					/*
					**  Active lease check
					**  @method: @Events/Leases/GetActiveLease
					*/

					if (resident) this.getActiveLeaseHandler(this.$route.params.id, resident.id);
				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

			/*
			**  Get the config options
			**  @method: @/Events/Config/GetLeaseOptions
			*/

        	this.getLeaseOptionsHandler();

        },

        /*
		**  Set up the methods
		*/

		methods: {

			openTheMenu: function() {

				try {

					/*
					**  Display the menu
					**  @prop: @here
					*/

					this.open_menu = true;

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Open the Create Lease Menu.',
                        errorType: 'Application',
                        section: 'Add Lease',
						uid: 'tLcVvnReNMkiPOKhyYCU',
                        error: e
                    });

				}

			},

			closeMenu: function() {

				try {
 
					/*
                    **  Close the menu
                    **  @prop: @here
                    */

					this.open_menu = false;
 
					/*
                    **  Emit the event
                    **  @service: @Vue
                    */

					this.$emit('closeAddLeaseMenu', true);

					/*
                    **  Reset the form props
                    **  @prop: @here
                    */

				   	this.resetValidationProps();

					/*
                    **  Reset the new_lease prop
                    **  @method: @Repositories/Leases/LeasesRepository
                    */

					this.resetNewLeaseProp();

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Close the Create Lease Menu.',
                        errorType: 'Application',
                        section: 'Add Lease',
						uid: '1KZbwqyPdnNeghN3ukeN',
                        error: e
                    });

				}

			},

			resetValidationProps: function() {

				try {

					/*
                    **  Reset the form props
                    **  @prop: @here
                    */

				   	this.active_lease_exists = false;
					this.lease_in_past = false;
					this.status = {
						error: false,
						title: null
					};
					this.lease_type = {
						error: false,
						title: null
					};
					this.start_date = {
						error: false,
						title: null
					};
					this.end_date = {
						error: false,
						title: null
					};
					this.notice_date = {
						error: false,
						title: null
					};

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Reset the validation props.',
                        errorType: 'Application',
                        section: 'Add Lease',
						uid: 'Egk37s6jcV66QryeLzVC',
                        error: e
                    });

				}

			},

			processFileUpload: function(file, load) {

				try {

					/*
					**  Set the file path
					*/
	
					let file_path = 'properties/' + this.$route.params.id + '/leases/';
	
					/*
					**  Store the file
					**  @method: @Events/Files/UploadFileToStorage
					*/

					this.uploadFileToStorageHandler(file, file_path, load);

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Process file upload.',
                        errorType: 'Application',
                        section: 'Add Lease',
						uid: 'dC1F7dPhE2CMLrBGOz7g',
                        error: e
                    });

				}

			},

			setDocumentsProp: function() {

				try {

					/*
                    **  Set the documents prop
                    **  @prop: @here
                    */

					this.new_lease.links.documents.push({
						id: this.file_name,
						title: this.file_name + '.' + this.file_extension,
						storage_url: this.download_url,
						created_at: moment().unix()
					});

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Reset the documents prop.',
                        errorType: 'Application',
                        section: 'Add Lease',
						uid: 'jkF4qFNbO87WFDnEdKrN',
                        error: e
                    });

				}

			},

			statusValidation: function() {

                try {

					/*
					**  Validate
					**  @props: @here
					*/

                    if (this.new_lease.attributes.status == '' || !this.new_lease.attributes.status || this.new_lease.attributes.status.length == 0) {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.status.error = true;
                        this.status.title = 'This is a required field.';

                    } else if (this.active_lease && this.new_lease.attributes.status == 'active') {

						/*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.status.error = true;
                        this.status.title = 'An active lease already exists for this resident.';

					} else {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.status.error = false;
                        this.status.title = null;

                    }

                    /*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to validate the status.',
						errorType: 'Application',
						section: 'Add Lease',
						uid: 'YSUKfnQoE19fXawJB6EI',
						error: e
					});

                }

			},

			leaseTypeValidation: function() {

                try {

                    if (this.new_lease.type == '' || !this.new_lease.type || this.new_lease.type.length == 0) {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.lease_type.error = true;
                        this.lease_type.title = 'This is a required field.';

                    } else {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.lease_type.error = false;
                        this.lease_type.title = null;

                    }

                    /*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to validate the lease type.',
						errorType: 'Application',
						section: 'Add Lease',
						uid: '4nJUcUSSMLeeuVQ160IQ',
						error: e
					});

                }

			},

			validateNoticeDate: function() {

				try {

					/*
					**  Set the vars
					*/

					let renewalDate = moment(this.new_lease.attributes.renewal.notice_date),
						startsAt = moment(this.new_lease.attributes.details.start_date),
						renewalNoticeBefore = startsAt.diff(renewalDate, 'days');

                    if (this.new_lease.attributes.renewal.send_notice && this.new_lease.attributes.renewal.notice_date == '' || this.new_lease.attributes.renewal.send_notice && !this.new_lease.attributes.renewal.notice_date || this.new_lease.attributes.renewal.send_notice && this.new_lease.attributes.renewal.notice_date.length == 0) {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.notice_date.error = true;
                        this.notice_date.title = 'This is a required field.';

                    } else if (renewalNoticeBefore > 0) {

						/*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.notice_date.error = true;
                        this.notice_date.title = 'Cannot be before the lease term start date.';

					} else {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.notice_date.error = false;
                        this.notice_date.title = null;

                    }

                    /*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to validate the lease type.',
						errorType: 'Application',
						section: 'Add Lease',
						uid: '4nJUcUSSMLeeuVQ160IQ',
						error: e
					});

                }

			},

			validateTermDates: function() {

				try {

					/*
					**  Set the vars
					*/

					let startDate = moment(this.new_lease.attributes.details.start_date),
						endDate = moment(this.new_lease.attributes.details.end_date),
						todaysDate = moment(),
						inThePast = startDate.diff(todaysDate, 'days'),
						endBeforeStart = endDate.diff(startDate, 'days');

					/*
					**  Set the vars
					*/

					if (inThePast < 0) {

						/*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.start_date.error = true;
                        this.start_date.title = 'Your lease cannot start in the past.';

					} else if (endBeforeStart < 0) {

						/*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.end_date.error = true;
                        this.end_date.title = 'Your end date cannot be set before the start date.';

					} else {

						/*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.start_date.error = false;
                        this.start_date.title = null;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to validate the term dates.',
						errorType: 'Application',
						section: 'Add Lease',
						uid: '3HUxFWaaZhrcInKwVOei',
						error: e
					});

				}

			},

			enableSubmitButtonCheck: function() {

                try {

					/*
					**  Can we enable the submit button?
					**  @props: @here
					*/

                    if (this.new_lease.attributes.status && this.new_lease.type && !this.status.error && !this.lease_type.error && !this.start_date.error && !this.end_date.error && !this.notice_date.error) {

                        /*
						**  Enable the create button
						**  @prop: @here
						*/

						this.enableCreateButton = true;

					} else {

						/*
						**  Disable the create button
						**  @prop: @here
						*/

						this.enableCreateButton = false;

					}

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to perform submit button check.',
						errorType: 'Application',
						section: 'Create Lease',
						uid: 'OTGtbcfFmy6UWLDUdI8e',
						error: e
					});

                }

            },

			setCalendarPickerIndex: function(event) {

                try {

                    /*
					**  Emit the event
					**  @service: @Vue
					*/

                    this.$emit('setCalendarPickerIndex', true);
                    
                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Emit the set calendar picker index event.',
						errorType: 'Application',
						section: 'Add Lease',
						uid: 'Lzw9fyExdgbAiHkaxhpa',
						error: e
					});

                }

            },

		}

	}

</script>